import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class CuentaAbonoSubject {

    private subAnexoContrato = new BehaviorSubject<boolean>(false);
    private subTerminosyCondiciones = new BehaviorSubject<boolean>(false);
    private hideObservable = new BehaviorSubject<boolean>(false);
    private showNumPasos = new BehaviorSubject<number>(0);

    hideObservable$ = this.hideObservable.asObservable();
    subAnexoContrato$ = this.subAnexoContrato.asObservable();
    subTerminosyCondiciones$ = this.subTerminosyCondiciones.asObservable();
    showNumPasos$ = this.showNumPasos.asObservable();

    showTerminosyCondiciones() {
        this.subAnexoContrato.next(false);
        this.subTerminosyCondiciones.next(true);
    }

    showAnexoContrato() {
        this.subAnexoContrato.next(true);
        this.subTerminosyCondiciones.next(false);
    }

    showPasosCuenta() {
        this.hideObservable.next(true);
    }

    showNumberPasos(pasos: number) {
        this.showNumPasos.next(pasos);
    }


}
